import { FcCheckmark } from "react-icons/fc";
import { AiOutlineClose } from "react-icons/ai";

export const navlist = [
  {
    text: "home",
    path: "/",
  },
  {
    text: "shop",
    path: "/shop",
  },
  {
    text: "about us",
    path: "/about",
  },
  {
    text: "blog",
    path: "/blog",
  },
  {
    text: "contact us",
    path: "/contact",
  },
];
export const hero = [
  {
    id: 1,
    cover: "../images/hero/cate-h11_1.png",
    name: "Web Themes",
    items: "5",
  },
  {
    id: 2,
    cover: "../images/hero/cate-h11_2.png",
    name: "UI Design",
    items: "12",
  },
  {
    id: 3,
    cover: "../images/hero/cate-h11_3.png",
    name: "3D Models",
    items: "12",
  },
  {
    id: 4,
    cover: "../images/hero/cate-h11_5.png",
    name: "Image Stock",
    items: "15",
  },
  {
    id: 5,
    cover: "../images/hero/cate-h11.png",
    name: "Mockup Design",
    items: "7",
  },
];
export const products = [
  {
    id: 1,
    cover: "../images/product/1-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: 30.0,
    category: "mockups",
    product_desc:
      "(1) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 2,
    cover: "../images/product/2-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: 10.0,
    category: "mockups",
    product_desc:
      "(2) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 3,
    cover: "../images/product/3-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: 20.0,
    category: "images stocks",
    product_desc:
      "(3) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 4,
    cover: "../images/product/4-3.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: 40.0,
    category: "images stocks",
    product_desc:
      "(4) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 5,
    cover: "../images/product/5-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "50.00",
    category: "web theme",
    product_desc:
      "(5) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 6,
    cover: "../images/product/6-3.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "25.00",
    category: "web theme",
    product_desc:
      "(6) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 7,
    cover: "../images/product/7-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "35.00",
    category: "icons",
    product_desc:
    "(7) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 8,
    cover: "../images/product/8-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "45.00",
    category: "icons",
    product_desc:
    "(8) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
];
export const banner = [
  {
    id: 1,
    title1: "Simple IPhone ",
    title2: "Mockups Design PSD, Ai, EPS",
    desc: "Sale 30% Off For Members",
    cover: "../images/banner/b2.png",
  },
  {
    id: 2,
    title1: "Mockup PSD",
    title2: "50+ Ui Screen Mockups",
    desc: "Sale 30% Off For Members",
    cover: "../images/banner/b1.png",
  },
];
export const topProducts = [
  {
    id: 20,
    cover: "../images/product/7-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "20.00",
    category: "icons",
    product_desc:
    "(10) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 21,
    cover: "../images/product/8-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "40.00",
    category: "icons",
    product_desc:
    "(11) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 22,
    cover: "../images/product/6-3.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "30.00",
    category: "web theme",
    product_desc:
    "(12) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },

  {
    id: 23,
    cover: "../images/product/5-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "35.00",
    category: "web theme",
    product_desc:
    "(13) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 24,
    cover: "../images/product/4-3.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "45.00",
    category: "images stocks",
    product_desc:
    "(14) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 25,
    cover: "../images/product/3-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "15.00",
    category: "images stocks",
    product_desc:
    "(15) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 26,
    cover: "../images/product/1-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "50.00",
    category: "mockups",
    produc_desc:
    "(16) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
  {
    id: 27,
    cover: "../images/product/2-1-1.jpg",
    title: "Floating 2021 iPhone 12 Mockups (PSD)",
    author: "by Blueskytechco in Mockups",
    price: "55.00",
    category: "mockups",
    product_desc:
    "(17) Designed by Puik in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique chinese armchairs.",
    qty: 0,
  },
];
export const price = [
  {
    id: 1,
    name: "Free Trial",
    price: "0",
    desc: "Beautifully simple project planning, 14 days of free trial.",
    list: [
      {
        para: "Demo Content Install",
        icon: <FcCheckmark />,
      },
      {
        para: "Theme Updates",
        icon: <FcCheckmark />,
      },
      {
        para: "Support And Updates",
        icon: <AiOutlineClose />,
      },
      {
        para: "Access All Themes",
        icon: <AiOutlineClose />,
      },
      {
        para: "All Themes For Life",
        icon: <AiOutlineClose />,
      },
      {
        para: "30 Days Money Back",
        icon: <AiOutlineClose />,
      },
    ],
  },
  {
    id: 2,
    name: "Premium",
    price: "26",
    desc: "Declutter your mind and save time with Premium.",
    list: [
      {
        para: "Demo Content Install",
        icon: <FcCheckmark />,
      },
      {
        para: "Theme Updates",
        icon: <FcCheckmark />,
      },
      {
        para: "Support And Updates",
        icon: <FcCheckmark />,
      },
      {
        para: "Access All Themes",
        icon: <FcCheckmark />,
      },
      {
        para: "All Themes For Life",
        icon: <AiOutlineClose />,
      },
      {
        para: "30 Days Money Back",
        icon: <AiOutlineClose />,
      },
    ],
  },
  {
    id: 3,
    name: "Unlimited Access ",
    price: "49",
    desc: "Declutter your mind and save time with Premium.",
    list: [
      {
        para: "Demo Content Install",
        icon: <FcCheckmark />,
      },
      {
        para: "Theme Updates",
        icon: <FcCheckmark />,
      },
      {
        para: "Support And Updates",
        icon: <FcCheckmark />,
      },
      {
        para: "Access All Themes",
        icon: <FcCheckmark />,
      },
      {
        para: "All Themes For Life",
        icon: <FcCheckmark />,
      },
      {
        para: "30 Days Money Back",
        icon: <FcCheckmark />,
      },
    ],
  },
];
export const customer = [
  {
    id: 1,
    desc: "Congue condimentum et non eu arcu sociis aenean vivamus quisque. Porta purus urna. Massa id blandit enim cursus ante, nec consectetuer imperdiet ipsum",
    name: "ALGISTINO",
    post: "Marketing Company Director",
  },
  {
    id: 2,
    desc: "Congue condimentum et non eu arcu sociis aenean vivamus quisque. Porta purus urna. Massa id blandit enim cursus ante, nec consectetuer imperdiet ipsum",
    name: "ALGISTINO",
    post: "Marketing Company Director",
  },
  {
    id: 3,
    desc: "Congue condimentum et non eu arcu sociis aenean vivamus quisque. Porta purus urna. Massa id blandit enim cursus ante, nec consectetuer imperdiet ipsum",
    name: "ALGISTINO",
    post: "Marketing Company Director",
  },
];
export const blog = [
  {
    id: 1,
    date: "October 27, 2021",
    title: "Transition Your Favorite Looks into  Fall France 2022",
    category: "image",
    cover: "../images/blog/b1.jpg",
  },
  {
    id: 2,
    date: "October 27, 2021",
    title: "Meeting Breathtaking Beauty for  Everyday Life",
    category: "shopping",
    cover: "../images/blog/b2.jpg",
  },
  {
    id: 3,
    date: "October 27, 2021",
    title: "Perfect Quality Reasonable Price for Your",
    category: "travle",
    cover: "../images/blog/b3.jpg",
  },
  {
    id: 4,
    date: "October 27, 2021",
    title: "Transition Your Favorite Looks into  Fall France 2022",
    category: "music",
    cover: "../images/blog/b4.jpg",
  },
  {
    id: 5,
    date: "October 27, 2021",
    title: "Meeting Breathtaking Beauty for  Everyday Life",
    category: "music",
    cover: "../images/blog/b5.jpg",
  },
  {
    id: 6,
    date: "October 27, 2021",
    title: "Perfect Quality Reasonable Price for Your",
    category: "lifestyle",
    cover: "../images/blog/b6.jpg",
  },
];
